import { render, staticRenderFns } from "./ClinicMedDic.vue?vue&type=template&id=727f0e50"
import script from "./ClinicMedDic.vue?vue&type=script&lang=js"
export * from "./ClinicMedDic.vue?vue&type=script&lang=js"
import style0 from "./ClinicMedDic.vue?vue&type=style&index=0&id=727f0e50&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\daima\\daima\\health-store\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('727f0e50')) {
      api.createRecord('727f0e50', component.options)
    } else {
      api.reload('727f0e50', component.options)
    }
    module.hot.accept("./ClinicMedDic.vue?vue&type=template&id=727f0e50", function () {
      api.rerender('727f0e50', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/business/page/dictionary/ClinicMedDic.vue"
export default component.exports